<template>
  <svg
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M14.27 29.6a.88.88 0 0 0 1.46 0c2.08-3.11 5.14-6.96 7.28-10.88 1.7-3.14 2.54-5.8 2.54-8.17a10.56 10.56 0 0 0-21.1 0c0 2.36.83 5.03 2.54 8.17 2.13 3.91 5.2 7.78 7.28 10.89ZM15 1.77a8.8 8.8 0 0 1 8.79 8.79c0 2.06-.76 4.46-2.32 7.33-1.84 3.37-4.47 6.8-6.47 9.68-2-2.88-4.63-6.3-6.47-9.68C6.97 15 6.21 12.6 6.21 10.55A8.8 8.8 0 0 1 15 1.75Z" fill="currentColor" />
    <path d="M15 15.82a5.28 5.28 0 1 0-.01-10.56A5.28 5.28 0 0 0 15 15.82Zm0-8.79a3.52 3.52 0 1 1 0 7.04 3.52 3.52 0 0 1 0-7.04Z" fill="currentColor" />
  </svg>
</template>
